import React from 'react'
import { TWITTER_PRIMARY_COLOR } from '../styles/colors'
import ShareButton, { ShareButtonProps } from './ShareButton'
import { TwitterIcon } from '../Icons'

export const TwitterShareButton: React.FC<ShareButtonProps> = props => (
  <ShareButton title="Tweet" color={TWITTER_PRIMARY_COLOR} {...props} icon={TwitterIcon} />
)
